import type {CmLogger} from "@cm/log"
import type {Color} from "@cm/graph-v3"
import * as changeCase from "change-case"

// an indexed property is named once, at index 0, since a ramp or curve holds as many elements as its material gives it
export const blenderNodeProperties = [
    "axis",
    "blendType",
    "clamp",
    "coloring",
    "colorMappingBlendColor",
    "colorMappingBlendFactor",
    "colorMappingBlendType",
    "colorMappingBrightness",
    "colorMappingColorRampColorMode",
    "colorMappingColorRampCyclesRampAlphaTable",
    "colorMappingColorRampCyclesRampColorTable",
    "colorMappingColorRampElements_0Alpha",
    "colorMappingColorRampElements_0Color_0",
    "colorMappingColorRampElements_0Position",
    "colorMappingColorRampHueInterpolation",
    "colorMappingColorRampInterpolation",
    "colorMappingContrast",
    "colorMappingSaturation",
    "colorMappingUseColorRamp",
    "colorRampColorMode",
    "colorRampCyclesRampAlphaTable",
    "colorRampCyclesRampColorTable",
    "colorRampElements_0Alpha",
    "colorRampElements_0Color_0",
    "colorRampElements_0Position",
    "colorRampHueInterpolation",
    "colorRampInterpolation",
    "dataType",
    "directionType",
    "disableProgressiveLoading",
    "displacementEnabled",
    "distribution",
    "gradientType",
    "extension",
    "factorMode",
    "falloff",
    "feature",
    "forceOriginalResolution",
    "fromInstancer",
    "imageColorspaceSettingsName",
    "imageFilepath",
    "inside",
    "interpolation",
    "invert",
    "isActiveOutput",
    "mappingBlackLevel",
    "mappingClipMaxX",
    "mappingClipMaxY",
    "mappingClipMinX",
    "mappingClipMinY",
    "mappingCurves_0Points_0HandleType",
    "mappingCurves_0Points_0Location",
    "mappingCyclesMappingTable",
    "mappingExtend",
    "mappingTone",
    "mappingUseClip",
    "mappingWhiteLevel",
    "musgraveDimensions",
    "musgraveType",
    "noiseDimensions",
    "noiseType",
    "normalize",
    "offset",
    "offsetFrequency",
    "onlyLocal",
    "operation",
    "projection",
    "projectionBlend",
    "samples",
    "shrink",
    "space",
    "squash",
    "squashFrequency",
    "subsurfaceMethod",
    "target",
    "textureMappingMapping",
    "textureMappingMappingX",
    "textureMappingMappingY",
    "textureMappingMappingZ",
    "textureMappingMax",
    "textureMappingMin",
    "textureMappingRotation",
    "textureMappingScale",
    "textureMappingTranslation",
    "textureMappingUseMax",
    "textureMappingUseMin",
    "textureMappingVectorType",
    "useAlpha",
    "useClamp",
    "uvMap",
    "uvMapIndex",
    "vectorType",
    "voronoiDimensions",
    "onlyLocal",
    "disabled",
    "dataType",
    "clampFactor",
    "clampResult",
    "interpolationType",
    "offsetFrequency",
    "squashFrequency",
    "gradientType",
    "musgraveDimensions",
    "musgraveType",
    "voronoiDimensions",
    "distance",
]

const atFirstIndices = (key: string) => key.replace(/_\d+/g, "_0")

export const isBlenderNodeProperty = (key: string) => blenderNodeProperties.includes(atFirstIndices(key))

export const removeInternalPrefixes = (parameters: Record<string, any>, logger: CmLogger): Record<string, any> & {color?: Color; label?: string} => {
    const cleanedParameters: Record<string, any> = {}
    for (const [key, value] of Object.entries(parameters)) {
        if (key === "internal.mute") {
            cleanedParameters["disabled"] = value
        } else if (blenderNodeProperties.some((param) => atFirstIndices(key).toLowerCase().startsWith(`internal${param}`.toLowerCase()))) {
            const newKey = changeCase.camelCase(key.replace(/^internal/, ""))
            cleanedParameters[newKey] = value
        } else {
            if (key.toLowerCase().startsWith(`internal`)) {
                logger.warn(`Unexpected internal parameter key: ${key}`)
            }
            cleanedParameters[key] = value
        }
    }
    return cleanedParameters
}
